import { Routes, Route, Navigate } from 'react-router-dom';
import { DiagnosticLoggerList } from '.';

export { DiagnosticLoggerLayout };

function DiagnosticLoggerLayout() {

    return (
        <div className="pt-16 px-12">            
            <Routes>
                <Route index element={<DiagnosticLoggerList />} />
                <Route path="/:busVin" element={<DiagnosticLoggerList />} />
            </Routes>
        </div>
    );
}
